var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneCommercialdepartment48 = function SvgAIconDualtoneCommercialdepartment48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15051_197564)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6689 19.4433C16.8289 19.4433 19.3905 16.8816 19.3905 13.7216C19.3905 10.5617 16.8289 8 13.6689 8C10.5089 8 7.94727 10.5617 7.94727 13.7216C7.94727 16.8816 10.5089 19.4433 13.6689 19.4433Z",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9606 47.6082L19.391 33.3041H22.2518V27.5825C22.2518 22.8425 18.4093 19 13.6694 19C8.92941 19 5.08691 22.8425 5.08691 27.5825V33.3041H7.94773L9.37814 47.6082H17.9606Z",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7715 30.8343H45.1391C46.7191 30.8343 47.9999 29.5535 47.9999 27.9735V7.94773C47.9999 6.36775 46.7191 5.08691 45.1391 5.08691H13.7715",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.543 20.8214L30.8342 16.5301L35.1254 20.8214L42.2775 13.6693",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5557 13.6693H42.2773V19.391",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58199 14.9433C12.742 14.9433 15.3036 12.3816 15.3036 9.22164C15.3036 6.06167 12.742 3.5 9.58199 3.5C6.42202 3.5 3.86035 6.06167 3.86035 9.22164C3.86035 12.3816 6.42202 14.9433 9.58199 14.9433Z",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8737 43.6082L15.3041 29.3041H18.1649V23.5825C18.1649 18.8425 14.3224 15 9.58246 15C4.8425 15 1 18.8425 1 23.5825V29.3041H3.86082L5.29123 43.6082H13.8737Z",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8872 26.7474H41.0521C42.6321 26.7474 43.9129 25.4666 43.9129 23.8866V3.86082C43.9129 2.28083 42.6321 1 41.0521 1H21.0264",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4561 16.7344L26.7473 12.4432L31.0385 16.7344L38.1906 9.5824",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4678 9.5824H38.1894V15.304",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6094 26.7473V36.7602",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8867 36.7603H35.33",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15051_197564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0002,
    height: 48,
    fill: "white"
  })))));
};
export { SvgAIconDualtoneCommercialdepartment48 as ReactComponent };
export default "data:image/svg+xml;base64,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";